import { render, staticRenderFns } from "./borrowing.component.vue?vue&type=template&id=43b1c800&scoped=true"
import script from "./borrowing.component.vue?vue&type=script&lang=ts"
export * from "./borrowing.component.vue?vue&type=script&lang=ts"
import style0 from "./borrowing.style.scss?vue&type=style&index=0&id=43b1c800&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b1c800",
  null
  
)

export default component.exports